import { mapState } from 'vuex'
import { versionAPI, PixelEndpoint } from '@api/_version'

export default {
  name: 'PixelSnippet',
  props: {
    customToken: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      pixelSnippet: '',
    }
  },
  computed: {
    ...mapState({
      userToken: (state) => state.users.currentUser.apiKey,
    }),
    token() {
      return this.customToken ? this.customToken : this.userToken
    },
  },
  created() {
    this.setPixelSnippet()
  },
  methods: {
    copyToClipboard() {
      this.$refs.textarea.select()
      document.execCommand('copy')
    },
    setPixelSnippet() {
      const endpoint =
        process.env.NODE_ENV === 'development'
          ? `http://localhost:8000/${versionAPI}`
          : PixelEndpoint
      const newLine = '&#013;'
      const pixelCode =
        '<!-- Start of Onvocado lead generation pixel - www.onvocado.com -->' +
        newLine +
        '&lt;script id=&quot;onvocadoScript&quot; type=&quot;text/javascript&quot;&gt;' +
        '(function (){' +
        newLine +
        'var onvocadoScriptTag=document.createElement(&quot;script&quot;);' +
        newLine +
        'onvocadoScriptTag.type=&quot;text/javascript&quot;;' +
        newLine +
        'onvocadoScriptTag.charset=&quot;utf-8&quot;;' +
        newLine +
        'onvocadoScriptTag.src=(&quot;' +
        endpoint +
        '/api/preload/?key=' +
        this.token +
        '&quot;);' +
        newLine +
        'var s=document.getElementById(&quot;onvocadoScript&quot;);' +
        newLine +
        's.parentNode.insertBefore(onvocadoScriptTag, s);' +
        newLine +
        '})(); &lt;/script&gt;' +
        newLine +
        '<!-- End of Onvocado lead generation pixel - www.onvocado.com -->'

      this.pixelSnippet = pixelCode
    },
  },
}
